import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form } from "react-bootstrap";
import Blue_border_button from "../../common_btn/blue_border_button/Blue_border_button";
import "./Study_Program_Details.css";
import Blue_btn from "../../common_btn/blue_btn/Blue_btn";
import { useState } from "react";
import Success_modal from "../../common_modal/success_modal/Success_modal";
import successAnimation from "../../../animation/success_lottie/Success_lottie.json";
import { IDS } from "../../../../utils/IDS";

const Study_Program_Details = ({
  schoolLogo,
  schoolName = " Toulouse Business School",
  address = "15 Pl. Vendôme, 75001 Paris, France",
  countryFlag = "https://flagcdn.com/w20/fr.png",
  bannerImg,
  programTitle = "Bachelor in Management",
  programSubtitle = "Bachelor in Management",
  highlights = [],
  eligibility = [],
  careers = [],
  documents = [],
  applicationFee = "€80",
  tuitionFee = "€9,000 per year",
  accommodation = "Optional",
  deadline = "30 November 2025",
  onBack,
  description,
}) => {
  const [modalSuccessShow, setModalsuccessShow] = useState(false);
  return (
    <>
      <div className="back_btn_holder">
        <Button className=" back_btn" onClick={onBack}>
          <div className="back_icon_holder">
            <FontAwesomeIcon icon={faAngleLeft} />
          </div>
          Back
        </Button>
      </div>

      <div className="tbs_card">
        <div className="tbs_card_header">
          <div className="tbs_header_info">
            <img
              src={schoolLogo ? IDS.IMG_URL + schoolLogo : ""}
              alt={schoolName}
              className="tbs_school_logo"
            />
            <h5 className="tbs_school_name">{schoolName}</h5>
          </div>

          <div className="d-flex gap-3 align-items-center">
            <h5 className="tbs_address">{address}</h5>
            <img
              src={countryFlag ? IDS.IMG_URL + countryFlag : ""}
              alt="flag"
              className="tbs_flag"
            />{" "}
          </div>
        </div>

        <div className="detail_banner_holder">
          {bannerImg && (
            <img
              src={IDS.IMG_URL + bannerImg}
              className="tbs_banner_img"
              alt="banner"
            />
          )}{" "}
        </div>

        <div className="tbs_body">
          <section className="tbs_section">
            <h3 className="tbs_main_title">{programTitle}</h3>
            {/* <p className="tbs_main_desc">
              Develop a solid foundation in business, leadership, and strategy
              through our {programTitle} program designed for future global
              professionals. Gain academic excellence, practical skills, and
              exposure to international business environment.
            // </p> */}
            <p className="tbs_main_desc">{description}</p>
          </section>

          <section className="tbs_section">
            <h4 className="tbs_main_title">{programSubtitle}</h4>
          </section>

          <section className="tbs_grid">
            <div className="tbs_column">
              <h5 className="tbs_column_title">Program Highlights</h5>
              <div className="form_holder">
                <Form>
                  <ul>
                    {highlights.map((item, i) => (
                      <li key={i}>
                        <Form.Check
                          type="checkbox"
                          label={item.Program_Highlight?.name}
                        />
                      </li>
                    ))}
                  </ul>
                </Form>
              </div>
            </div>

            <div className="tbs_column">
              <h5 className="tbs_column_title">
                Eligibility &amp; Requirements
              </h5>
              <div className="form_holder">
                <Form>
                  <ul>
                    {eligibility.map((item, i) => (
                      <li key={i}>
                        <Form.Check
                          type="checkbox"
                          label={item.Eligibility_Requirement?.name}
                        />
                      </li>
                    ))}
                  </ul>
                </Form>
              </div>
            </div>

            <div className="tbs_column">
              <h5 className="tbs_column_title">Career Opportunities</h5>
              <div className="form_holder">
                <Form>
                  <ul>
                    {careers.map((item, i) => (
                      <li key={i}>
                        <Form.Check
                          type="checkbox"
                          label={item.Career_Requirement?.name}
                        />
                      </li>
                    ))}
                  </ul>
                </Form>
              </div>
            </div>

            <div className="tbs_column">
              <h5 className="tbs_column_title">Required Documents</h5>
              <div className="form_holder">
                <Form>
                  <ul>
                    {documents.map((item, i) => (
                      <li key={i}>
                        <Form.Check
                          type="checkbox"
                          label={item.Requirement_Document?.name}
                        />
                      </li>
                    ))}
                  </ul>
                </Form>
              </div>
            </div>

            <div className="tbs_column">
              <h5 className="tbs_column_title">Program Fees</h5>
              {/* <p className="column_text">Application Fee: {applicationFee}</p> */}
              <p className="column_text">Application Fee: €{applicationFee}</p>
              {/* <p className="column_text">Tuition Fee: {tuitionFee}</p> */}
              <p className="column_text">Tuition Fee: €{tuitionFee}</p>
              {/* <p className="column_text">Accommodation: {accommodation}</p>////////// */}
            </div>
            <div className="tbs_column">
              {/* <p className="column_text">Application Deadline: {deadline}</p> */}
              <p className="column_text">
                Application Deadline: {new Date(deadline).toLocaleDateString()}
              </p>
            </div>
          </section>

          <div className="bottom_btn_holder">
            <Blue_btn btn_text={"Apply Now"} />
            <Blue_border_button
              button_text={"Download Brochure"}
              onClick={() => setModalsuccessShow(true)}
            />
          </div>
        </div>
      </div>

      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Downloading Brochure"}
        animationData={successAnimation}
      />
    </>
  );
};
export default Study_Program_Details;
